import React, { ComponentType, FC } from 'react';
import { HelmetProvider as AsyncHelmetProvider } from 'react-helmet-async';


export const HelmetProvider:FC<{ Next: ComponentType }> = ({ Next }) => (
    <AsyncHelmetProvider>
        <Next />
    </AsyncHelmetProvider>
);
